import { Coffee, Library, SquarePen, Settings, Wallet } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useAppStore } from '@/lib/store';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';

export function FloatingNav() {
    const { themeProfile, showSettings, setShowSettings } = useAppStore();
    const { user } = useAuth();
    const location = useLocation();

    const activeStyle = {
        backgroundColor: themeProfile.accent,
        color: themeProfile.background,
        boxShadow: `0 8px 20px ${themeProfile.accent}40`
    };

    const inactiveStyle = {
        color: themeProfile.text,
        opacity: 0.65
    };

    const navItems = [
        { id: 'read', label: 'Coffee Shop', to: '/read', icon: Coffee, active: location.pathname === '/' || location.pathname === '/read' || location.pathname === '/feed' || location.pathname === '/coffee-house' },
        { id: 'library', label: 'Library', to: '/library', icon: Library, active: location.pathname === '/library' },
        { id: 'support', label: 'Support', to: '/support', icon: Wallet, active: location.pathname === '/support' },
        ...(user ? [{ id: 'studio', label: 'Studio', to: '/study', icon: SquarePen, active: location.pathname.startsWith('/study') }] : []),
    ];

    return (
        <div
            className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center p-1.5 rounded-full backdrop-blur-xl border shadow-2xl transition-all duration-300 animate-in fade-in slide-in-from-bottom-4"
            style={{
                backgroundColor: `${themeProfile.paperSurface}CC`,
                borderColor: `${themeProfile.border}66`,
            }}
        >
            <nav className="flex items-center gap-1">
                {navItems.map(({ id, label, to, icon: Icon, active }) => (
                    <Link
                        key={id}
                        to={to}
                        className={cn(
                            'flex items-center gap-2 px-3 md:px-4 py-2.5 rounded-full text-sm font-semibold transition-all duration-300',
                            active ? 'scale-105' : 'scale-100 hover:bg-current/10 hover:opacity-100'
                        )}
                        style={active ? activeStyle : inactiveStyle}
                    >
                        <Icon className="w-4 h-4" />
                        <span className={active ? 'block' : 'hidden md:block'}>{label}</span>
                    </Link>
                ))}

                <div className="w-[1px] h-6 mx-1" style={{ backgroundColor: themeProfile.border, opacity: 0.3 }} />

                <button
                    onClick={() => setShowSettings(!showSettings)}
                    className={cn(
                        'p-2.5 rounded-full transition-all duration-300',
                        showSettings ? 'scale-110 rotate-90' : 'scale-100 hover:rotate-45'
                    )}
                    style={{
                        backgroundColor: showSettings ? themeProfile.accent : 'transparent',
                        color: showSettings ? themeProfile.background : themeProfile.text,
                        opacity: showSettings ? 1 : 0.65
                    }}
                    title="Global Settings"
                >
                    <Settings className="w-4 h-4" />
                </button>
            </nav>
        </div>
    );
}
